import { FC } from 'react'
import { useTranslation } from 'react-i18next'

import { Accordion } from '../accordion/accordion'

export const PrivacyAccordion: FC = () => {
  const { t } = useTranslation()

  return (
    <Accordion
      title={t('commons.read_more_label')}
      classes_head="m-0 p-0 pt-2 justify-content-between flex-nowrap width-fit-content"
      classes_title="m-0 p-0 mr-2 font-18 text-underline"
    >
      <p className="m-0 p-0 mt-1 font-16 c-7f7f7f">
        {t('commons.read_more_text')}
        <u
          onClick={() =>
            window.open('https://www.gruppoitas.it/gruppo/note-legali-e-privacy', '_blank')
          }
        >
          {'link'}
        </u>
        {'.'}
      </p>
    </Accordion>
  )
}
